import React from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactPinField from "react-pin-field";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePassOtp, changePassOtpVerify } from "../../store/actions";
import { toast } from "react-toastify";

const OtpScreen = ({ state, setState, setFieldTab }) => {
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  const email = useSelector((s) => s?.login?.userEmail);

  const handleChange = (val) => {
    setOtp(val);
  };

  const handleSubmit = (e, val) => {
    e.preventDefault();

    const callBack = (res) => {
      if (res.status == 200) {
        setFieldTab(val);
        toast.success("OTP Verified Successfully!");
      } else {
        toast.error(res.error);
      }
    };
    dispatch(changePassOtpVerify({ otp: otp, email: email }, callBack));
  };

  const handleResendSubmit = (e) => {
    e.preventDefault();

    const callBack = (res) => {
      if (res.status == 200) {
        toast.success("OTP Sent!");
      } else {
        toast.error(res.error);
      }
    };

    dispatch(changePassOtp(state, callBack));
  };

  return (
    <Row>
      <Col lg="12" className="my-2 change-otp">
        <div className="edit-pass d-flex align-items-center">
          <label className="m-0 form-label2 m-0 me-3 text-center w-100">
            Enter Otp sent on your Email
          </label>
        </div>
        <div
          className={"icon-with-div pass position-relative otp-field mt-4 mb-3"}
        >
          <ReactPinField
            style={{ width: "50px", height: "40px" }}
            class="pin-field"
            validate="0123456789"
            length="6"
            onChange={handleChange}
          />
        </div>
        <div className="text-center">
          <button className="resend-btn" onClick={handleResendSubmit}>
            Resend OTP
          </button>
        </div>
      </Col>
      <Col lg="12" className="my-2">
        <div className="pt-4 btn-wrp d-flex align-items-center text-center justify-content-center">
          <Button
            className="d-flex align-items-center justify-content-center me-2"
            onClick={(e) => handleSubmit(e, "reset")}
            disabled={otp == "" ? true : false}
          >
            Submit
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default OtpScreen;
